import { useNavigate } from 'react-router-dom';
import fullLogo from '../_Assets/Full_logo_TWB.svg';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src={fullLogo} alt="Membify" className="legal-logo" />
          <button className="back-btn" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
            Tilbage
          </button>
        </div>

        <div className="legal-content">
          <h1>Privatlivspolitik</h1>
          <p className="legal-date">Sidst opdateret: 28. april 2026</p>

          <section>
            <h2>1. Dataansvarlig</h2>
            <p>Membify ApS er dataansvarlig for behandlingen af dine personoplysninger. Har du spørgsmål til vores behandling af dine data, er du velkommen til at kontakte os på <a href="mailto:privacy@membify.dk">privacy@membify.dk</a>.</p>
          </section>

          <section>
            <h2>2. Hvilke oplysninger indsamler vi?</h2>
            <p>Vi indsamler følgende personoplysninger, når du opretter en konto eller bruger vores tjeneste:</p>
            <ul>
              <li>Navn og e-mailadresse</li>
              <li>Login-oplysninger (krypteret adgangskode)</li>
              <li>Betalingsoplysninger (behandles sikkert via tredjepart)</li>
              <li>Brugsdata og aktivitetslog på platformen</li>
              <li>Tekniske data såsom IP-adresse, browsertype og enhedsoplysninger</li>
            </ul>
          </section>

          <section>
            <h2>3. Formål med behandlingen</h2>
            <p>Vi bruger dine oplysninger til at:</p>
            <ul>
              <li>Oprette og administrere din konto</li>
              <li>Levere og forbedre vores tjenester</li>
              <li>Sende servicerelaterede meddelelser (fx kvitteringer og sikkerhedsadvarsler)</li>
              <li>Overholde lovgivningsmæssige forpligtelser</li>
              <li>Forebygge misbrug og svindel</li>
            </ul>
          </section>

          <section>
            <h2>4. Retsgrundlag</h2>
            <p>Behandlingen af dine personoplysninger sker på følgende retsgrundlag i henhold til GDPR:</p>
            <ul>
              <li><strong>Opfyldelse af kontrakt</strong> — behandling nødvendig for at levere vores tjeneste (art. 6, stk. 1, litra b)</li>
              <li><strong>Retlig forpligtelse</strong> — fx bogføringsloven (art. 6, stk. 1, litra c)</li>
              <li><strong>Legitime interesser</strong> — sikkerhed og forebyggelse af misbrug (art. 6, stk. 1, litra f)</li>
              <li><strong>Samtykke</strong> — markedsføring og nyhedsbreve (art. 6, stk. 1, litra a)</li>
            </ul>
          </section>

          <section>
            <h2>5. Opbevaring af data</h2>
            <p>Vi opbevarer dine personoplysninger så længe, det er nødvendigt for at opfylde de formål, de er indsamlet til, eller som krævet ved lov. Kontodata slettes senest 30 dage efter lukning af din konto, medmindre lovgivning kræver længere opbevaring.</p>
          </section>

          <section>
            <h2>6. Deling med tredjepart</h2>
            <p>Vi sælger ikke dine personoplysninger. Vi kan dele data med:</p>
            <ul>
              <li>Betalingsudbydere til behandling af transaktioner</li>
              <li>Hostingudbydere og cloud-tjenester</li>
              <li>Analyseværktøjer (anonymiseret)</li>
              <li>Myndigheder, hvis vi er retligt forpligtet hertil</li>
            </ul>
            <p>Alle databehandlere er underlagt databehandleraftaler og behandler kun data efter vores instruktion.</p>
          </section>

          <section>
            <h2>7. Overførsel til tredjelande</h2>
            <p>Dine data behandles primært inden for EU/EØS. Hvis data overføres til lande uden for EU/EØS, sker det kun med passende sikkerhedsgarantier, fx EU's standardkontraktbestemmelser.</p>
          </section>

          <section>
            <h2>8. Dine rettigheder</h2>
            <p>Du har følgende rettigheder i henhold til GDPR:</p>
            <ul>
              <li><strong>Indsigt</strong> — du kan anmode om en kopi af de oplysninger, vi har om dig</li>
              <li><strong>Berigtigelse</strong> — du kan få ukorrekte oplysninger rettet</li>
              <li><strong>Sletning</strong> — du kan anmode om sletning af dine data ("retten til at blive glemt")</li>
              <li><strong>Begrænsning</strong> — du kan anmode om begrænsning af behandlingen</li>
              <li><strong>Dataportabilitet</strong> — du kan få dine data udleveret i et maskinlæsbart format</li>
              <li><strong>Indsigelse</strong> — du kan gøre indsigelse mod behandling baseret på legitime interesser</li>
            </ul>
            <p>Send din anmodning til <a href="mailto:privacy@membify.dk">privacy@membify.dk</a>. Vi besvarer henvendelser inden for 30 dage.</p>
          </section>

          <section>
            <h2>9. Cookies</h2>
            <p>Vi anvender nødvendige cookies til drift af platformen samt analytiske cookies til at forbedre brugeroplevelsen. Du kan til enhver tid ændre dine cookieindstillinger via vores cookiebanner.</p>
          </section>

          <section>
            <h2>10. Klageadgang</h2>
            <p>Du har ret til at indgive klage til Datatilsynet, hvis du mener, at vi behandler dine personoplysninger i strid med databeskyttelseslovgivningen. Se mere på <a href="https://www.datatilsynet.dk" target="_blank" rel="noreferrer">datatilsynet.dk</a>.</p>
          </section>

          <section>
            <h2>11. Ændringer til denne politik</h2>
            <p>Vi forbeholder os retten til at opdatere denne privatlivspolitik. Ved væsentlige ændringer vil vi give dig besked via e-mail eller en synlig meddelelse på platformen.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
